import { withRouter } from "react-router-dom";
import Cookies from "js-cookie";
import { Redirect, Link } from "react-router-dom";
import "../Audit/Audit.css";
import { useEffect, useState } from "react";
import axios from "axios";
import fileDownload from "js-file-download";
import { Button, Layout, Modal, Select } from "antd";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import FileTransfer from "../../Components/FileTransfer/FileTransfer";
import CredentialsUpdate from "../../Components/CredentialsUpdate/CredentialUpdate";
const { Header } = Layout;
const Audit = () => {
  const jwtToken = Cookies.get("jwt_token");
  const userLogin = Cookies.get("UserLogin");
  //vms dropdown
  const [result, getdata] = useState([]);
  //frequency dropdown
  const [frequency, getFrequency] = useState([]);
  //Blur flag
  const [isloading, setloading] = useState(false);
  //progress bar flag
  const [showProgressbar, setShowProgressbar] = useState(false);
  const [targetKeys, setTargetKeys] = useState([]); // selected clients list
  const [selectedKeys, setSelectedKeys] = useState([]);
  var count;
  var countIncrement = 0;

  //Progress Clients Count Data
  const [totalClients, setTotalClients] = useState();
  const [downloadedClients, setDownloadedClients] = useState(0);
  const [sampleVms, setSampleVms] = useState();

  const [outputFrequency, setFrequency] = useState([]); //Frequency

  //Download All State for Clients List
  const [clientsOfVMS, setClientsOfVMS] = useState([]);
  const [now, setNow] = useState(0);
  const [progressWidth, setProgressWidth] = useState(false);

  //Get Clients State Variables
  const [vmsClients, setVmsClients] = useState([]);
  const [selectedVms, setSelectedVms] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    callClientsList();
    callFrequencyList();
  }, []);
  const callClientsList = async () => {
    const res = await axios(
      `${process.env.REACT_APP_BASE_URL}Home/getvmslist`,
      {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    const temp = res.data;
    getdata(temp);
  };
  const callFrequencyList = async () => {
    const res = await axios(`${process.env.REACT_APP_BASE_URL}Home/frequency`, {
      method: "GET",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    const tempdata = res.data;
    getFrequency(tempdata);
  };
  const progressCloseButton = () => {
    setShowProgressbar(false);
  };
  const downloadFiles = async (e) => {
    setShowProgressbar(false);
    try {
      const response = await axios({
        url:
          `${process.env.REACT_APP_BASE_URL}Home/DownloadZipFile?filename=` +
          userLogin,
        method: "GET",
        responseType: "blob",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      fileDownload(response.data, "Payroll.zip");
      DeleteFiles();
      setIsModalOpen(false);
    } catch (error) {
      DeleteFiles();
      setIsModalOpen(false);
      console.log(error);
    }
  };
  const DeleteFiles = (e) => {
    axios({
      url:
        `${process.env.REACT_APP_BASE_URL}Home/deleteFiles?userLogin=` +
        userLogin,
      method: "GET",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    }).catch((err) => alert(err));
  };
  // --------------------- Download all Api --------------------------------------------------------------------------
  const handleClick = async () => {
    var len = 0;
    len = selectedVms.length;

    try {
      console.log("testing");
      var i = 0;
      let testVms = [];

      for (i = 0; i < len; i++) {
        setClientsOfVMS([]);
        setShowProgressbar(false);
        setDownloadedClients(0);
        countIncrement = 0;
        setNow(parseInt(countIncrement));
        testVms = selectedVms[i];
        setSampleVms(testVms);
        try {
          const resp = await axios.get(
            `${process.env.REACT_APP_BASE_URL}Home/getclientslist/` + testVms,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
              },
            }
          );
          clientsOfVMS.push(resp.data);
          let length = resp.data.length;
          count = 100 / length;
          setTotalClients(length);
          let j = 0;
          let eachClient = [];
          for (j = 0; j < length; j++) {
            setloading(true);
            setShowProgressbar(true);
            setProgressWidth(true);
            setloading(true);
            eachClient = [];
            eachClient.push(clientsOfVMS[i][j]);
            try {
              const res = await axios.post(
                `${process.env.REACT_APP_BASE_URL}Home/DownloadForSelectedClients?VMS=` +
                  testVms +
                  `&frequency=` +
                  outputFrequency +
                  `&userLogin=` +
                  userLogin,
                JSON.stringify(eachClient),
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                  },
                }
              );
              console.log(res);
              callNowPercentage(count, j);
            } catch (errs) {
              console.log("**Error Message**  :" + errs);
            }
          }
        } catch (err) {
          console.log("**Error Message**  :" + err);
        }
      }
      setloading(false);
      setShowProgressbar(false);
      setIsModalOpen(true);
      info();
    } catch (Apierror) {
      console.log("**Error Message**  :" + Apierror);
    }
  };
  //Api to Download Reports For Selected Clients
  const DownloadEachCLient = async (eachCLient) => {
    const url =
      `${process.env.REACT_APP_BASE_URL}Home/DownloadForSelectedClients?VMS=` +
      selectedVms +
      `&frequency=` +
      outputFrequency +
      `&userLogin=` +
      userLogin;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    };
    const DownloadResponse = await axios.post(
      url,
      JSON.stringify(eachCLient),
      config
    );
  };
  // Download Selected clients
  const DownloadForSelected = async () => {
    try {
      setShowProgressbar(false);
      setDownloadedClients(0);
      countIncrement = 0;
      setNow(parseInt(countIncrement));
      let length = targetKeys.length;
      count = 100 / length;
      setTotalClients(length);
      let j = 0;
      let eachClient = [];
      for (j = 0; j < length; j++) {
        // BlurFlag(true);
        setloading(true);
        setShowProgressbar(true);
        setProgressWidth(true);
        // BlurFlag(true);
        eachClient = [];
        eachClient.push(targetKeys[j]);
        try {
          await DownloadEachCLient(eachClient);
          callNowPercentage(count, j);
        } catch (errs) {
          console.log("**Error Message**  :" + errs);
        }
      }
      // BlurFlag(false);
      setloading(false);
      setShowProgressbar(false);
      // setIsModalOpen(true);
      info();
    } catch (Apierror) {
      console.log("**Error Message**  :" + Apierror);
    }
  };
  const callNowPercentage = async (count, int) => {
    setProgressWidth(true);
    countIncrement = countIncrement + count;
    setNow(parseInt(countIncrement));
    setDownloadedClients(int + 1);
  };
  if (jwtToken === undefined) {
    return <Redirect to="/" />;
  }
  const info = () => {
    Modal.info({
      icon: null,
      title: "Finished processing your request, Click OK to download the files",
      onOk() {
        downloadFiles();
        setIsModalOpen(false);
        setloading(false);
      },
    });
  };
  //Fetch Clients Of Vms
  const GetClientsListOfVms = async (vms) => {
    setTotalClients(0);
    setSelectedKeys([]);
    setTargetKeys([]);
    console.log(vms);
    //Setting selected Vms
    setSelectedVms(vms);
    const url = `${process.env.REACT_APP_BASE_URL}Home/getclientslist/` + vms;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    };
    //Api call
    if (vms.length === 0) {
      setVmsClients([]);
    } else {
      const CLientsResponse = await axios.get(url, config);
      setVmsClients(CLientsResponse.data);
    }
  };

  return (
    <>
      <Layout
        className={isloading ? "blur" : ""}
        style={{ overflow: "hidden" }}
      >
        <div style={{ zIndex: "10" }}>
          <SideNavBar />
        </div>
        <Layout
          className="whole-layout"
          style={{ backgroundColor: "white", zIndex: "1" }}
        >
          <Header className="audit-header">
            <Navbar />
          </Header>
          <div className="select-clients-background-image">
            <div>
              <div className="body-containers">
                <div className="select-client-elements">
                  <div>
                    <Select
                      className="select-elements"
                      mode="multiple"
                      size="large"
                      style={{ width: 150 }}
                      placeholder="Select VMS"
                      allowClear
                      maxTagCount="responsive"
                      onChange={(newValue) => {
                        GetClientsListOfVms(newValue);
                      }}
                    >
                      {result
                        ? result.map((item, index) => {
                            return (
                              <Select.Option key={index} value={item}>
                                {item}
                              </Select.Option>
                            );
                          })
                        : null}
                    </Select>
                  </div>
                  <div>
                    <Select
                      className="select-elements"
                      size="large"
                      placeholder="Select Frequency"
                      onChange={(newFreq) => {
                        setFrequency(newFreq);
                      }}
                    >
                      {frequency.map((items, index) => {
                        return (
                          <Select.Option key={index} value={items}>
                            {items}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </div>
                  <div className="button-container">
                    <button
                      className="button"
                      onClick={handleClick}
                      disabled={
                        selectedVms.length === 0 || outputFrequency.length === 0
                      }
                    >
                      Download All
                    </button>
                  </div>
                </div>
                <div className="tranfer-otherpages-class">
                  <div className="otherpage-buttons">
                    <Link to="/payrollhoursaudit"><Button className="page-button">Payroll Hours Audit</Button></Link>
                    <Link to="/preview"><Button className="page-button">Preview/Review</Button></Link>
                    <Link to="/payrollchecklist"> <Button className="page-button">Payroll Checklist</Button></Link>
                    <Button className="currentpage-button">Selected Crawling</Button>
                    
                    {/* <Link to="/activitylog"><Button className="page-button">Activity Log</Button></Link> */}
                  </div>
                  <div className="transfer-footers">
                    <FileTransfer
                      targetKeys={targetKeys}
                      setTargetKeys={setTargetKeys}
                      selectedKeys={selectedKeys}
                      setSelectedKeys={setSelectedKeys}
                      clientsList={vmsClients}
                      Vms={selectedVms}
                      frequency={outputFrequency}
                    />
                    <div className="footer-buttons">
                      <button
                        className=" foo-button"
                        onClick={() => DownloadForSelected()}
                        disabled={
                          targetKeys.length === 0 || outputFrequency.length === 0
                        }
                      >
                        Download Selected Clients
                      </button>
                      {/* <CredentialsUpdate /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Layout>
      </Layout>
      {showProgressbar && (
        <div className="popup">
          <div className="popup-inner">
            <div className="name-progress">
              <div className="download-head">Downloading...</div>
              <div className="progressbar">
                <div className="progress-div">
                  {progressWidth && (
                    <div
                      className="filled-progressbar"
                      style={{ width: now + "%" }}
                    >
                      <span style={{ fontSize: 12 }}>{now}%</span>
                    </div>
                  )}
                </div>
              </div>
              <div className="Vms-status">
                {downloadedClients} out of {totalClients} in{" "}
                {selectedVms.length > 1 ? sampleVms : selectedVms}
              </div>
              <button className="close-btn" onClick={progressCloseButton}>
                Ok
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default withRouter(Audit);
